// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ajaF","image":"Header_image__BWCNW","name":"Header_name__3S9o8","info":"Header_info__inlnb","infoRow":"Header_infoRow__3DIv9"};